module.exports = __webpack_public_path__ + "img/Whiet-label-bi-platform.d57c23e7.png";